<template>
    <div>
        <v-dialog
            v-if="isMobile"
            v-model="dialog"
            persistent
            scrollable
            overlay-opacity="0"
            width="500"
            class="harmony-materials"
            @click:outside="closeDialog"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-list-item-action class="ma-0">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        class="harmony-info"
                        :ripple="false"
                    >
                        <v-icon class="icon">
                            icon-info
                        </v-icon>
                    </v-btn>
                </v-list-item-action>
            </template>
            <v-card class="harmony-materials__card">
                <v-toolbar
                    dense
                    :elevation="0"
                >
                    <v-toolbar-title
                        v-if="harmonyName"
                        class="h3 font-weight-bold"
                    >
                        {{ `${harmonyName[0].toUpperCase()}${harmonyName.toLowerCase().slice(1)}` }}
                    </v-toolbar-title>
                    <v-spacer/>
                    <v-toolbar-items>
                        <v-btn
                            :elevation="0"
                            icon
                            x-small
                            :ripple="false"
                            @click="dialog = false"
                            :width="24"
                            :height="24"
                        >
                            <v-icon
                                class="icon"
                                color="black"
                            >
                                icon-close
                            </v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>

                <v-list-item-group>
                    <v-list-item
                        v-for="(materialObj, materialObjIndex) in materials"
                        :key="`material-text-${materialObjIndex}`"
                        class="material"
                        :class="{ 'pb-2': materialObjIndex === materials.length - 1 }"
                        :ripple="false"
                        inactive
                    >
                        <v-list-item-icon class="material-preview d-flex justify-center my-0 mr-2 pt-2">
                            <MaterialPreview :materialId="materialObj.id"/>
                        </v-list-item-icon>
                        <v-list-item-content class="material-description">
                            <v-list-item-title
                                class="habiteo-body-2 text-none"
                            >
                                {{ materialObj.text[0].toUpperCase()+materialObj.text.toLowerCase().slice(1) }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-card>
        </v-dialog>


        <!-- HARMONY - CUSTOM MATERIAL DESCRIPTIONS -->
        <v-menu
            v-else
            offset-y
            z-index="14"
            class="harmony-materials no-custom"
            @click:outside="active = false"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-list-item-action class="ma-0">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="harmony-info"
                        icon
                        :ripple="false"
                        :height="24"
                        :width="24"
                        @click="active = active"
                        v-click-outside="resetActive"
                    >
                        <v-icon class="icon icon-info"/>
                    </v-btn>
                </v-list-item-action>
            </template>
            <v-list
                class="harmony-materials pa-0"
                dense
                disabled
            >
                <v-toolbar
                    dense
                    :elevation="0"
                >
                    <v-toolbar-title
                        v-if="harmonyName"
                        class="h3 font-weight-bold"
                    >
                        {{ harmonyName }}
                    </v-toolbar-title>

                    <v-spacer/>

                    <v-toolbar-items>
                        <v-btn
                            icon
                            class="ml-4"
                            :elevation="0"
                            :ripple="false"
                            @click="dialog = false"
                        >
                            <v-icon
                                small
                                class="icon icon-close"
                            />
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list-item-group>
                    <v-list-item
                        v-for="(materialObj, materialObjIndex) in materials"
                        :key="`material-text-${materialObjIndex}`"
                        :ripple="false"
                        inactive
                    >
                        <v-list-item-icon class="material-preview d-flex justify-center my-1 mr-2">
                            <MaterialPreview :materialId="materialObj.id"/>
                        </v-list-item-icon>
                        <v-list-item-content class="material-description">
                            <v-list-item-title class="habiteo-body-2 text-none">
                                {{ materialObj.text[0].toUpperCase()+materialObj.text.toLowerCase().slice(1) }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-menu>
        <!-- /HARMONY - CUSTOM MATERIAL DESCRIPTIONS -->
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapActions, mapGetters } from 'vuex';

    import MaterialPreview from '@/components/configurableTour/components/MaterialPreview';

    export default {
        name: 'HarmonyMaterials',
        components: {
            MaterialPreview
        },
        props: {
            harmonyName: {
                type: String,
                required: false
            },
            materials: {
                type: Array
            }
        },
        data: () => ({
            dialog: false,
            active: false
        }),
        computed: {
            ...mapGetters([
                'disableCloseSidebar'
            ]),
            isMobile() {
                return this.$vuetify.breakpoint.xs;
            }
        },
        methods: {
            ...mapActions([
                'setDisableCloseSidebarStatus'
            ]),
            resetActive() {
                this.active = false;
            },
            closeDialog() {
                EventBus.$on('toggleSidebar', false);
                this.dialog = false;
            }
        },
        watch: {
            dialog(val) {
                setTimeout(() => { this.setDisableCloseSidebarStatus(val) }, 100);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/configurableTour/components/HarmonyMaterials.vue